import type { BackupDocument, BackupStore, LocalBackupGateway } from "../ports/backup";

export async function createRemoteBackup(
  dependencies: { readonly local: LocalBackupGateway; readonly remote: BackupStore },
): Promise<BackupDocument> {
  const document = await dependencies.local.createDocument();
  await dependencies.local.validate(document);
  await dependencies.remote.upload(document);
  return document;
}

/** A recoverable local safety backup is uploaded before local data is replaced. */
export async function restoreLatestRemoteBackup(
  dependencies: { readonly local: LocalBackupGateway; readonly remote: BackupStore },
): Promise<BackupDocument> {
  const incoming = await dependencies.remote.downloadLatest();
  if (!incoming) throw new Error("No remote backup exists");
  // Download and authentication do not inspect or mutate local user data, so
  // they deliberately happen before acquiring the cross-tab write lock.
  await dependencies.local.validate(incoming);
  await dependencies.local.replaceFromWithSafetyBackup(
    incoming,
    (safetyBackup) => dependencies.remote.upload(safetyBackup),
  );
  return incoming;
}
